// extracted by mini-css-extract-plugin
module.exports = {"Player":"Player_Player__g3joS","Player--cover":"Player_Player--cover__mBs9N"};